export default __webpack_public_path__ + "maps-guides-view-annotation-simple-1200-a54bf8c9bfe8d8aa93a10e1a354166e5.webp";